/**
 * Asking the client beside her to sit in the empty chair.
 *
 *   "if sunroom one is booked and we add on a NAD to the appointment and we
 *    had another client booked in that seat can it re seat the booked client
 *    to the empty chair? Will it be able to understand that?"
 *
 * It can. The server works out who would have to move and where - a chair of
 * the same sort, free for the whole of their stay, that their treatment is
 * allowed in - and refuses the save with that plan attached. Nobody is moved
 * until the desk has read the plan and said yes, and nobody who has already
 * arrived is offered at all: they are sitting in that chair.
 */

export interface ReseatMove {
  appointment_id: string;
  segment_id: string;
  /** Who is being asked to sit somewhere else. */
  client: string;
  service: string;
  from_room_id: string;
  from_room: string;
  to_room_id: string;
  to_room: string;
  starts_at: string;
  ends_at: string;
}

/** The plan carried by a refused save (`ApiError.data`), if there is one. */
export function reseatPlan(data: unknown): ReseatMove[] {
  const moves = (data as { moves?: unknown } | null | undefined)?.moves;
  if (!Array.isArray(moves)) return [];
  return moves.filter((m): m is ReseatMove =>
    !!m && typeof m === "object" && typeof (m as ReseatMove).to_room === "string");
}

/** "Gillian Ward moves out of Sunroom Chair 1 into Sunroom Chair 3 at 11:30." */
export function reseatLines(moves: readonly ReseatMove[], time: (iso: string) => string): string[] {
  return moves.map((m) =>
    `${m.client} moves out of ${m.from_room} into ${m.to_room} at ${time(m.starts_at)}.`);
}

/** What the toast says once it is done: where to look for them. */
export function reseatSummary(moves: readonly ReseatMove[]): string | undefined {
  if (moves.length === 0) return undefined;
  return `${moves.map((m) => `${m.client} is now in ${m.to_room}`).join(", ")}.`;
}
